export const APP_CONFIG = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || '/api',
  accessTokenStorageKey: process.env.REACT_APP_ACCESS_TOKEN_STORAGE_KEY || 'access_token',
  persistedStorageKey: process.env.REACT_APP_PERSISTED_STORAGE_KEY || 'financial_wizard_data',
};

export const BRANDING = {
  companyName: process.env.REACT_APP_COMPANY_NAME || 'Marcellus',
  logoAlt: process.env.REACT_APP_LOGO_ALT || 'Marcellus Logo',
  websiteUrl: process.env.REACT_APP_WEBSITE_URL || 'https://marcellus.in',
  logoPath: process.env.REACT_APP_LOGO_PATH || '/assets/Marcellus-Logo.png',
};
